import { FC } from 'react'
import { isRouteErrorResponse, useRouteError } from 'react-router-dom'

/**
 * Роут прятал любую ошибку чанка за полноэкранным лоадером (`<MainLayout loading />`),
 * и после `?error_import_module=1` экран зависал навсегда. Показываем текст ошибки.
 */
export const RouteError: FC = () => {
  const error = useRouteError()
  const message = isRouteErrorResponse(error)
    ? `${error.status} ${error.statusText}`
    : error instanceof Error
    ? [error.message, error.stack].filter(Boolean).join('\n')
    : String(error)

  return (
    <pre data-testid="route-error" style={{ padding: 32, margin: 0, whiteSpace: 'pre-wrap', overflow: 'auto' }}>
      {message}
    </pre>
  )
}
